import { buildSubModuleRoute } from '@/app/arch/helpers/RouterHelper';
import PrivacyPolicy from 'Modules/contacard/legalAgreements/PrivacyPolicy/routes';
import TermsOfUse from 'Modules/contacard/legalAgreements/TermsOfUse/routes';
import LegalContract from 'Modules/contacard/legalAgreements/contract/routes';

export default [
  buildSubModuleRoute({
    name: 'legalAgreements',
    moduleId: 'contacard',
    path: 'legal-agreements',
    subModuleTitle: 'Termos legais',
    children: [
      ...PrivacyPolicy,
      ...TermsOfUse,
      ...LegalContract,
    ],
  }),
];
